import { BlockTimeRateMarginInterface } from '../interfaces/block-time-rate-margin.interface';

/**
 * Calculates the rate (profit / cost) and the flight margin (profit / (cost + profit)) in percent.
 * A value that is not a finite number gives 0, for example when the cost is 0.
 */
export function calculateRateAndFlightMargin(
  cost: number | null | undefined,
  profit: number | null | undefined,
): BlockTimeRateMarginInterface {
  const costValue = Number(cost);
  const profitValue = Number(profit);

  return {
    rate: toPercent((profitValue / costValue) * 100),
    flightMargin: toPercent((profitValue / (costValue + profitValue)) * 100),
  };
}

function toPercent(value: number): number {
  return Number.isFinite(value) ? Number(value.toFixed(2)) : 0;
}
